const isProduction = process.env.VUE_APP_ENV === 'production';
const formUrlDomain = isProduction
  ? 'https://form.motionelements.com' // prod
  : 'https://stage-form.motionelements.work'; // stage, dev

export default function (currentLocale, formId) {
  const supportedLocales = ['en', 'ja', 'ko', 'zh-hant'];
  const lang = supportedLocales.includes(currentLocale) ? currentLocale : 'en';
  return `${formUrlDomain}/${lang}/forms/${formId}`;
}
